/**
 * TrendModa — Ürün Kartı Sepete Ekle (AJAX)
 * Koleksiyon / anasayfa ürün kartlarındaki "Sepete Ekle" butonunu yönetir.
 */
(function () {
  'use strict';
  if (window.TrendModaCardATC) return;
  window.TrendModaCardATC = true;

  function getRoute(routeName, fallback) {
    if (window.routes && window.routes[routeName]) return window.routes[routeName];
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/?$/, '/') + fallback.replace(/^\//, '');
  }

  function getSectionIds(cartDrawer) {
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return [];
    return cartDrawer.getSectionsToRender().map(function (section) { return section.id; }).filter(Boolean);
  }

  function openCartDrawer(cartDrawer, data, btn, sectionIds) {
    if (!cartDrawer) return Promise.resolve();
    if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(btn);

    var hasRenderedSections = sectionIds.length > 0 && data.sections && sectionIds.every(function (id) {
      return typeof data.sections[id] === 'string' && data.sections[id].length > 0;
    });

    if (hasRenderedSections && typeof cartDrawer.renderContents === 'function') {
      try {
        cartDrawer.renderContents(data);
        return Promise.resolve();
      } catch (error) {
        console.error('[card-atc] cart drawer render:', error);
      }
    }

    var sectionId = sectionIds[0] || 'cart-drawer';
    var cartUrl = getRoute('cart_url', 'cart');
    var separator = cartUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(cartUrl + separator + 'section_id=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Sepet bölümü yüklenemedi');
        return response.text();
      })
      .then(function (html) {
        if (typeof cartDrawer.renderContents !== 'function') return;
        var sections = {};
        sections[sectionId] = html;
        cartDrawer.renderContents({
          sections: sections,
          item_count: data.item_count,
          items: data.items,
        });
      })
      .catch(function (error) {
        console.error('[card-atc] cart drawer refresh:', error);
        if (typeof cartDrawer.open === 'function') cartDrawer.open(btn);
      });
  }

  function addToCart(variantId, btn) {
    if (btn.dataset.busy === 'true') return;
    var numericVariantId = Number(variantId);
    if (!Number.isSafeInteger(numericVariantId) || numericVariantId <= 0) return;
    btn.dataset.busy = 'true';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    var originalHTML = btn.innerHTML;
    btn.classList.add('ty-card__atc--loading');
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation:spin .7s linear infinite"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".25"/><path d="M21 12a9 9 0 0 0-9-9"/></svg> Ekleniyor…';

    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer');
    var sectionsParam = getSectionIds(cartDrawer);

    var payload = {
      items: [{ id: numericVariantId, quantity: 1 }]
    };
    if (sectionsParam.length > 0) {
      payload.sections = sectionsParam;
      payload.sections_url = window.location.pathname + window.location.search;
    }

    fetch(getRoute('cart_add_url', 'cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Ürün eklenemedi');
          return data;
        });
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Ürün eklenemedi');
        }

        btn.classList.remove('ty-card__atc--loading');
        btn.classList.add('ty-card__atc--success');
        btn.innerHTML =
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Sepete Eklendi!';

        updateCartCount(data, cartDrawer);

        var drawerPromise = openCartDrawer(cartDrawer, data, btn, sectionsParam);

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-atc',
              productVariantId: String(variantId),
              cartData: data,
            });
          } catch (publishError) {
            console.error('[card-atc] cart update event:', publishError);
          }
        }
        return drawerPromise;
      })
      .catch(function (err) {
        console.error('[card-atc]', err);
        btn.classList.remove('ty-card__atc--loading');
        btn.classList.add('ty-card__atc--error');
        btn.innerHTML = 'Hata — Tekrar Dene';
      })
      .finally(function () {
        setTimeout(function () {
          btn.dataset.busy = 'false';
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.classList.remove('ty-card__atc--loading', 'ty-card__atc--success', 'ty-card__atc--error');
          btn.innerHTML = originalHTML;
        }, 2500);
      });
  }

  function updateCartCount(data, cartDrawer) {
    if (typeof data.item_count === 'number') {
      if (cartDrawer && typeof cartDrawer.updateCartCount === 'function') {
        cartDrawer.updateCartCount(data.item_count);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item_count: data.item_count } }));
      }
      return;
    }
    fetch(getRoute('cart_url', 'cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartDrawer && typeof cartDrawer.updateCartCount === 'function') {
          cartDrawer.updateCartCount(cart.item_count);
          return;
        }
        document.querySelectorAll('.ty-header__action--cart .ty-header__cart-count, #cart-count, [data-bnav-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.hasAttribute('data-bnav-cart-count')) el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item_count: cart.item_count } }));
      })
      .catch(function () {});
  }

  // Beden seçici — tıklanan bedeni seç ve variant id'yi güncelle
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.ty-card__size:not(.ty-card__size--disabled)');
    if (!sizeBtn) return;
    e.preventDefault();
    var sizesWrap = sizeBtn.closest('.ty-card__sizes');
    if (sizesWrap) {
      sizesWrap.querySelectorAll('.ty-card__size').forEach(function (b) {
        b.classList.remove('ty-card__size--selected');
        b.setAttribute('aria-pressed', 'false');
      });
      sizesWrap.classList.remove('ty-card__sizes--attention');
    }
    sizeBtn.classList.add('ty-card__size--selected');
    sizeBtn.setAttribute('aria-pressed', 'true');
    var card = sizeBtn.closest('.ty-card');
    if (card) {
      var atcBtn = card.querySelector('.ty-card__atc');
      if (atcBtn && sizeBtn.dataset.variantId) {
        atcBtn.dataset.variantId = sizeBtn.dataset.variantId;
        atcBtn.removeAttribute('data-requires-size');
        atcBtn.setAttribute('aria-disabled', 'false');
        atcBtn.setAttribute('aria-label', 'Sepete ekle');
        var label = atcBtn.querySelector('[data-atc-label]');
        if (label) label.textContent = 'Sepete Ekle';
      }
      card.dataset.variantId = sizeBtn.dataset.variantId;
    }
  });

  // Sepete ekle — event delegation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ty-card__atc');
    if (!btn) return;
    e.preventDefault();
    // e.stopPropagation() kaldırıldı, çünkü iOS Safari'de touch-to-click dönüşümünü ve diğer event'leri bozabiliyor
    var variantId = btn.dataset.variantId;
    if (btn.dataset.requiresSize === 'true' || !variantId) {
      var card = btn.closest('.ty-card');
      var sizes = card ? card.querySelector('[data-card-sizes]') : null;
      if (sizes) {
        sizes.classList.add('ty-card__sizes--attention');
        var firstSize = sizes.querySelector('.ty-card__size:not(.ty-card__size--disabled)');
        if (firstSize) firstSize.focus({ preventScroll: true });
      }
      return;
    }
    addToCart(variantId, btn);
  });

  // CSS spin animasyonu (bir kez ekle)
  if (!document.getElementById('ty-atc-spin-style')) {
    var style = document.createElement('style');
    style.id = 'ty-atc-spin-style';
    style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }
})();
